import Actions from '../../../constants/inventory/InventoryActions';
import {
  AddActionLabels,
  RemoveActionLabels
} from '../../../constants/inventory/Reasons';

const {
  ADD,
  MOVE,
  REMOVE,
  DAMAGED,
  SPOILED,
  FOUND_NEW,
  LOST,
  EXPIRED,
  STOLEN,
  DONATION_RECEIVED,
  DONATION_REMOVED,
  DONATED,
  ADD_CORRECTION,
  REMOVE_CORRECTION,
  PURCHASED,
  SOLD,
  DISTRIBUTION_RECEIVED,
  DISTRIBUTED,
  POS_ADD,
  POS_DEDUCT,
  POS_CANCELED
} = Actions;

export const AddReasonOptions = [
  { group: 'Add', value: ADD, label: AddActionLabels[ADD] },
  {
    group: 'Add',
    value: ADD_CORRECTION,
    label: AddActionLabels[ADD_CORRECTION]
  },
  { group: 'Add', value: FOUND_NEW, label: AddActionLabels[FOUND_NEW] },
  { group: 'Add', value: PURCHASED, label: AddActionLabels[PURCHASED] },
  {
    group: 'Add',
    value: DONATION_RECEIVED,
    label: AddActionLabels[DONATION_RECEIVED]
  },
  {
    group: 'Add',
    value: DISTRIBUTION_RECEIVED,
    label: AddActionLabels[DISTRIBUTION_RECEIVED]
  },
  { group: 'Add', value: POS_DEDUCT, label: AddActionLabels[POS_DEDUCT] },
  { group: 'Add', value: POS_CANCELED, label: AddActionLabels[POS_CANCELED] }
];

export const RemoveReasonOptions = [
  {
    group: 'Deduct',
    value: REMOVE,
    label: RemoveActionLabels[REMOVE]
  },
  {
    group: 'Deduct',
    value: DONATION_REMOVED,
    label: RemoveActionLabels[DONATION_REMOVED]
  },
  {
    group: 'Deduct',
    value: REMOVE_CORRECTION,
    label: RemoveActionLabels[REMOVE_CORRECTION]
  },
  { group: 'Deduct', value: DONATED, label: RemoveActionLabels[DONATED] },
  {
    group: 'Deduct',
    value: DISTRIBUTED,
    label: RemoveActionLabels[DISTRIBUTED]
  },
  { group: 'Deduct', value: SOLD, label: RemoveActionLabels[SOLD] },
  { group: 'Deduct', value: DAMAGED, label: RemoveActionLabels[DAMAGED] },
  { group: 'Deduct', value: SPOILED, label: RemoveActionLabels[SPOILED] },
  { group: 'Deduct', value: LOST, label: RemoveActionLabels[LOST] },
  { group: 'Deduct', value: EXPIRED, label: RemoveActionLabels[EXPIRED] },
  { group: 'Deduct', value: STOLEN, label: RemoveActionLabels[STOLEN] },
  { group: 'Deduct', value: POS_ADD, label: RemoveActionLabels[POS_ADD] }
];

export const MoveReasonOption = {
  value: MOVE,
  label: 'Move',
  group: 'Move'
};
